import React, { CSSProperties, useState } from 'react'
import './TabBar.scss'

interface TabItem {
  title: string
  component: JSX.Element
}

interface IProps {
  items: TabItem[]
  headerClassName?: string
  headerStyle?: CSSProperties
}

export function TabBar(props: IProps) {
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const tabs = props.items.map((item, index) => {
    return tabBox(item, index)
  })

  function tabBox(item: TabItem, tabIndex: number) {
    const isSelected = activeTabIndex === tabIndex
    return (
      <div
        key={tabIndex}
        className={`tab-item ${isSelected && 'active'}`}
        onClick={() => {
          setActiveTabIndex(tabIndex)
        }}
      >
        <p
          className="title"
          style={{
            cursor: isSelected ? 'default' : 'pointer',
          }}
        >
          <span>{item.title}</span>
        </p>
      </div>
    )
  }

  return (
    <div className="tab-bar">
      <div className={`tab-header ${props.headerClassName}`} style={props.headerStyle}>
        {tabs}
      </div>
      <div className="tab-content">{React.cloneElement(props.items[activeTabIndex].component)}</div>
    </div>
  )
}

export default TabBar
